import React, {Component} from 'react';

class Estratto2  extends Component {
    render() {
        return (
            <section id={this.props.widgetId} className="ftco-section testimony-section img ftco-animate">
                <div className="overlay"></div>
                <div className="container">
                    <div className="row d-md-flex justify-content-center">
                        <div className="col-md-8 mb-5 heading-section text-left ftco-animate">
                            <div className="text-panel">
                                <h2 className="mb-4">{this.props.widgetTitolo}</h2>
                                <p className="mb-5" dangerouslySetInnerHTML={{ __html: this.props.widgetContenuto }}></p>
                            </div>
                            {this.props.widgetButtonLink ? (
                                <>
                                    <br /> 
                                    <p><a href={this.props.widgetButtonLink} className="btn btn-info py-3 px-4" target="_blank" rel="noreferrer noopener">{this.props.widgetButton}</a></p>
                                </>
                            ) : null}                            
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
// /*<iframe className="row text-center justify-content-center" title="widget" width="300px" height="550px" src={this.props.estrattoLink}></iframe>*/
export default Estratto2;